"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogin = exports.loginContext = exports.Provider = void 0;
var _react = require("react");
const loginContext = exports.loginContext = /*#__PURE__*/(0, _react.createContext)(undefined);
const {
  Provider
} = loginContext;
exports.Provider = Provider;
const useLogin = () => {
  const context = (0, _react.useContext)(loginContext);
  if (context === undefined) {
    throw new Error('Value for `loginContext` must be set.');
  }
  return context;
};
exports.useLogin = useLogin;
//# sourceMappingURL=loginContext.js.map